import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const Crotchet = () => {

    return (
        <SvgIcon >
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns: xlink="http://www.w3.org/1999/xlink"
                xml: space="preserve">
                <path fill="#000000" opacity="1.000000" stroke="none"
                    d="M14 3V13.56C13.41 13.21 12.73 13 12 13C9.79 13 8 14.79 8 17S9.79 21 12 21 16 19.21 16 17V3H14Z" />
            </svg>
        </SvgIcon >
    );
};

export default Crotchet;
